module.exports = "/_next/static/images/Christopher_Johnson-c9dc3381cd356d57201813f19a66680f.webp";